import { useEffect, useState, useRef, useContext } from 'react';
import './index.scss'
import { getlogin, getlist, getUserListForPad } from '../../api/common';
import JSEncrypt from 'jsencrypt'
import { useHistory } from "react-router-dom";
import Const from '../../utils/Const';
import { Select } from 'antd';
const { Option } = Select;
/**登录 */
interface Props {

}
const Index = (parent: Props) => {
    const [input, setInput]: any = useState('');
    const [userList, setUserList]: any = useState([]);
    const [userName, setUserName]: any = useState();
    const [isTip, setIsTip]: any = useState(false);
    const [tiptext, setTipText]: any = useState(false);
    const history = useHistory();
    let time: any;

    useEffect(() => {
        getUserList()
        return () => {
            clearTimeout(time);
        }
    }, [])

    const inputChange = (e) => {
        setInput(e.target.value)
    }

    const encryptRSA = (str: any) => {
        const encryptor = new JSEncrypt()
        const publicKey = `MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCosgdi/hTJ59SpnvsgzG37J2TcpHMqqTzsYU2kN2PMqTpmBWlTbQVv4XPmlEWqJaeHlL06bweXBOCoHxwmdAdBldUFvFmgeJpOLG4Xbp6EXvbxSvFus3tuxAmc+40oAL5a2sdaH6Oy0y/cpwYakP8V9UHFCLTYXT+/mnuZKLMbawIDAQAB`
        encryptor.setPublicKey(publicKey)
        const rsaPassWord = encryptor.encrypt(str)
        return rsaPassWord
    }

    const getLogin = () => {
        const loginForm = {
            username: userName,
            password: input,
        }
        getlogin({ str: encryptRSA(JSON.stringify(loginForm)) }).then((res: any) => {
            console.log(res)
            if (res.success) {
                sessionStorage.setItem('token', res.data.token)
                sessionStorage.setItem('path', '/list')
                history.push(`/list`);
            } else {
                setIsTip(true)
                setTipText(res.msg)
                time = setTimeout(() => {
                    setIsTip(false)
                    setTipText('')
                }, 3000)
            }
        })
    };

    const getUserList = () => {
        getUserListForPad().then((res: any) => {
            console.log(res)
            setUserList(res.data);
        })
    }

    const userSelectChange = (value) => {
        setUserName(value)
    }

    return <div className="main-content login">
        {isTip && <div className="tip-box">{tiptext}</div>}

        <div className="tit flex-c-c">登录</div>
        <div className="content">
            <div className="login-form flex-c-c">
                <div className='select-box'>
                    <div className="selectIcon"></div>
                    <Select popupClassName="user-select" style={{ width: 1160 }} onChange={userSelectChange}>
                        {userList.map((e, i) => {
                            return (
                                <Option value={e.userName} key={`option${i}`}>{e.stationName}</Option>
                            )
                        })}
                        {/* <Option value="2222">2222</Option>
                        <Option value="3333">3333</Option> */}
                    </Select>
                </div>
                <div className="input-box flex-c-l">
                    <div className="icon"></div>
                    <input type="text" onChange={inputChange} />
                </div>
                <div className="btn flex-c-c" onClick={getLogin}>确定</div>
            </div>
        </div>
    </div>
}
export default Index
